var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCoracaoOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 24.054,
    viewBox: "0 0 25.5 24.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_57_37",
    "data-name": "Componente 57 \\u2013 37",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M54.995,59.628A6.118,6.118,0,0,1,61,65.854c0,6.226-6.005,9.771-12,16-6-6.226-12-9.771-12-16a6.117,6.117,0,0,1,6-6.226c3,0,4.5,1.557,6,4.669C50.5,61.185,52,59.628,54.995,59.628Z",
    transform: "translate(-37 -59.628)",
    fill: "#d13c8d",
    stroke: "#d13c8d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCoracaoOver);
export default __webpack_public_path__ + "static/media/ico-coracao-over.4092bf2aa5b8bc7048708c9531554473.svg";
export { ForwardRef as ReactComponent };